import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import type { OutreachLiveTotals } from '../outreachTypes';
import { percentOrNull } from './campaignFormat';
import { campaignPageMessages as messages } from './campaignPageMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the campaign page; each part uses its own slice of it */
import styles from './Campaign.module.scss';
/* eslint-enable css-modules/no-unused-class */

/**
 * The five totals of the campaign (design outreach-v2 g1): pitched, opened the song, listened 30 s+,
 * replied and added the song. A part of today shows as "+3 today"; "Opened" shows its percent.
 */
const StatsRowComponent: React.FC<{ totals: OutreachLiveTotals }> = ({ totals }) => {
  const intl = useIntl();
  const items = useMemo(() => {
    const opened = percentOrNull(totals.opened.total, totals.pitched.total);
    const cards = [
      { key: 'pitched', label: messages.statPitched, count: totals.pitched, extra: null },
      {
        key: 'opened',
        label: messages.statOpened,
        count: totals.opened,
        extra: opened === null ? null : intl.formatMessage(messages.statPercent, { percent: opened }),
      },
      { key: 'listened', label: messages.statListened, count: totals.listened, extra: null },
      { key: 'replied', label: messages.statReplied, count: totals.replied, extra: null },
      { key: 'added', label: messages.statAdded, count: totals.placed, extra: null },
    ];
    return cards.map((card) => {
      const small =
        card.extra ??
        (card.count.today > 0
          ? intl.formatMessage(messages.statToday, { count: intl.formatNumber(card.count.today) })
          : null);
      return (
        <div key={card.key} className={styles.stat} data-testid={`campaign-stat-${card.key}`}>
          <div className={styles.statKey}>{intl.formatMessage(card.label)}</div>
          <div className={styles.statValue}>
            {intl.formatNumber(card.count.total)}
            {small !== null && <small>{small}</small>}
          </div>
        </div>
      );
    });
  }, [intl, totals]);
  return <div className={styles.stats}>{items}</div>;
};

export const StatsRow = TypedMemo(StatsRowComponent);
